// Used for pages that need to auth & get Warrior BUT not game
import { useRouter } from 'next/router';
import { createContext, useContext } from 'react';

import { Warrior } from '~/../api/common.types';
import { WarriorAuthenticationProviderTypes } from '~/contextProviders/WarriorAuthenticationProvider/WarriorAuthenticationProvider.types';
import { useGetOwnedWarriors } from '~/hooks/game/useGetOwnedWarriors';
import { useGetAccount } from '~/hooks/web3/useGetAccount';
import { isAliveWarrior, particpatedInWar } from '~/utils/utils';

const WarriorContext = createContext({} as WarriorAuthenticationProviderTypes);

const WarriorAuthenticationProvider = ({
  children,
  accessTokenRequired,
}: {
  children: any;
  accessTokenRequired?: boolean;
}) => {
  const router = useRouter();
  const inChoice = router?.pathname.includes('/choice');
  const inRevival = router?.pathname.includes('/revival');
  const { data: connectedAccount } = useGetAccount();

  const {
    data: warriorsResult,
    isLoading: isLoadingWarriors,
    isSuccess: hasLoadedWarriors,
    fetchNextPage: loadMoreWarriors,
    isFetchingNextPage: isLoadingMore,
  } = useGetOwnedWarriors(accessTokenRequired, connectedAccount?.address);

  const hasMore =
    warriorsResult?.pages[warriorsResult?.pages.length - 1]?.hasMore || false;
  let warriors: Array<Warrior> = [];
  warriorsResult?.pages.forEach((page) => {
    if (page?.warriors) warriors.push(...(page.warriors as [Warrior]));
  });

  if (inChoice) {
    warriors = warriors?.filter(
      (warrior) => particpatedInWar(warrior) && isAliveWarrior(warrior)
    );
  }

  if (inRevival) {
    warriors = warriors?.filter((warrior) => !isAliveWarrior(warrior));
  }

  return (
    <WarriorContext.Provider
      value={{
        warriors: warriors as [Warrior],
        hasMore,
        loadMore: () => {
          if (hasMore) loadMoreWarriors();
        },
        isLoading: isLoadingWarriors,
        isLoadingMore,
        hasLoadedWarriors: hasLoadedWarriors,
      }}
    >
      {children}
    </WarriorContext.Provider>
  );
};

export default WarriorAuthenticationProvider;

export function useWarriorAuthentication(): WarriorAuthenticationProviderTypes {
  return useContext(WarriorContext);
}
